export const IRA_RELATIONSHIP_SPOUSE = 'spouse';
export const IRA_RELATIONSHIP_SON = 'son';
export const IRA_RELATIONSHIP_DAUGTHER = 'daughter';
export const IRA_RELATIONSHIP_OTHERRELATIVE = 'otherrelative';
export const IRA_RELATIONSHIP_FRIEND = 'friend';
export const IRA_RELATIONSHIP_ESTATE = 'estate';
export const IRA_RELATIONSHIP_ORGANIZATIONCHARIRY = 'organizationcharity';
